"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@emotion/core");
const lodash_1 = require("lodash");
const design_system_1 = require("@zapier/design-system");
const DrawerIconButton = (props) => {
    const { isDisabled, label, name, onClick } = props;
    return (core_1.jsx(design_system_1.IconButton, { ariaLabel: label, disabled: isDisabled || !onClick, icon: name, label: lodash_1.startCase(label), onClick: onClick, size: "xsmall", tooltipPosition: props.labelPosition }));
};
DrawerIconButton.defaultProps = {
    isDisabled: false,
    labelPosition: 'west',
};
exports.default = DrawerIconButton;
